import user from './user';

export const apiInstance = user.getAxiosInstance();
